import { render, staticRenderFns } from "./project-tracker.vue?vue&type=template&id=27e84941&scoped=true&"
import script from "./project-tracker.vue?vue&type=script&lang=js&"
export * from "./project-tracker.vue?vue&type=script&lang=js&"
import style0 from "./project-tracker.vue?vue&type=style&index=0&id=27e84941&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e84941",
  null
  
)

export default component.exports